/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */
// import Global from './global';

'use strict';
const CheckoutForm = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom	for any jQuery selectors
	 * @param {string} class for any class strings
	 * @param {string} attr for any data attributes strings
	 */

	$domOrderComments: $('#order_comments_field [for="order_comments"]'),
	$domOrderCommentsTextArea: $('[name="order_comments"]'),
	$domCouponWrap: $('.woocommerce-form-coupon-custom-wrapper'),
	$domRewOrderTable: $('.woocommerce-checkout-review-order-table'),

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		this.rename();
		this.appendEls();
		this.populateCheckoutForm();
		this.couponLoader();
		this.priceChange();
		this.onlyNumbers();
        // Fix no shipping methods before selecting state
        if ($('body').hasClass('woocommerce-checkout')) {
            $('body').trigger('update_checkout');
        };
	},

	onlyNumbers() {
	    const input = document.getElementById('billing_phone_extension');
	
	    if (!input) {
	        return;
	    }
	
	    const onlyNum = function() {
	        this.value = this.value.replace(/[^\d]/g, '');
	    };
	
	    input.addEventListener('keyup', onlyNum);
	},

	rename: function() {
		CheckoutForm.$domOrderComments.html('Notes');
		CheckoutForm.$domOrderCommentsTextArea.attr('placeholder', 'Order comments? Write here.');
	},

	couponLoader: function() {
		$('.js-coupon-btn').on('click', function() {
			$(this).addClass('coupon-btn--hidden');
			$('.loader').removeClass('hidden');

			setTimeout(function() {
				$('.js-coupon-btn').removeClass('coupon-btn--hidden');
				$('.loader').addClass('hidden');
			}, 5000);
		});
	},
	priceChange: function() {
		// monitor changes in input field
		$('.js-salesman-input')
		.on('input change', function(e) {
			const Price = parseFloat($(e.target).val());
			const IsDisabled = isNaN(Price) || Price <= 0;
			$(e.target).closest('.js-salesman-ctrl').find('.js-salesman-btn-save')
			.toggleClass('disabled', IsDisabled)
			.prop('disabled', IsDisabled);
		})
		.on('keydown', function(e) {
			// simulate click on "back" if pressed Esc
			if (e.keyCode === 27) {
				$(this).closest('.js-salesman-inputs').find('.js-salesman-btn-back').trigger('click');
			}
			// simulate click on "save" if pressed Enter
			if (e.keyCode === 13) {
				e.preventDefault(); // dont submit checkout form
				$(this).closest('.js-salesman-inputs').find('.js-salesman-btn-save:not(:has(.disabled))').trigger('click');
			}
		});

		// handle click on salesman "change price" button
		$('.js-salesman-btn-change').on('click', function(e) {
			const Item = $(this).closest('.js-order-item');
			const Ctrl = $(this).closest('.js-salesman-ctrl');
			UpdateSalesmanPriceState(Item, Ctrl, 2);
			Ctrl.find('.js-salesman-btn-save').toggleClass('disabled', true).prop('disabled', true);
			Ctrl.find('.js-salesman-input').val('')[0].focus(); // clear input and set focus
		});

		// handle click on salesman "save" button
		$('.js-salesman-btn-save').on('click', function(e) {
			if ($(e.target).hasClass('disabled')) {
				return;
			}
			$('body').addClass('cart-overlay');
			const Item = $(this).closest('.js-order-item');
			const Ctrl = $(this).closest('.js-salesman-ctrl');
			const CtrlName = Ctrl.data('ctrl');
			$.ajax({
				url: kadraGlobal.ajax,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'salesman-price',
					ctrlName: CtrlName,
					productId: Item.data('product_id'),
					value: Ctrl.find('.js-salesman-input').val(),
				},
				success: function(data) {
					if (!data.success) {
						UpdateSalesmanPriceState(Item, Ctrl, 1);
						return;
					}
					Ctrl.find('.salesman-value').html(data.data.value);
					//Item.find('.js-salesman-price-new').html('$' + data.data.price);
					UpdateSalesmanPriceState(Item, Ctrl, 3);
					$('body').trigger('update_checkout');
				},
				error: function() {
					UpdateSalesmanPriceState(Item, Ctrl, 1);
				},
				complete: function() {
					$('body').removeClass('cart-overlay');
				}
			});
		});

		// handle click on salesman "back" button
		$('.js-salesman-btn-back').on('click', function(e) {
			const Ctrl = $(this).closest('.js-salesman-ctrl');
			const NewState = Ctrl.find('.salesman-value').html() || '' !== '' ? 3 : 1;
			UpdateSalesmanPriceState($(this).closest('.js-order-item'), Ctrl, NewState);
		});

		// handle click on salesman "restore" button
		$('.js-salesman-btn-restore').on('click', function(e) {
			$('body').addClass('cart-overlay');
			const Item = $(this).closest('.js-order-item');
			const Ctrl = $(this).closest('.js-salesman-ctrl');
			const CtrlName = Ctrl.data('ctrl');
			$.ajax({
				url: kadraGlobal.ajax,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'remove-salesman-price',
					ctrlName: CtrlName,
					productId: Item.data('product_id'),
				},
				// eslint-disable-next-line no-unused-vars
				success: function() {
					Ctrl.find('.salesman-value').html('');
					UpdateSalesmanPriceState(Item, Ctrl, 1);
					$('body').trigger('update_checkout');
				},
				error: function() {
					UpdateSalesmanPriceState(Item, Ctrl, 3);
				},
				complete: function() {
					$('body').removeClass('cart-overlay');
				}
			});
			UpdateSalesmanPriceState(Item, Ctrl, 1);
		});

		// set initial visibility
		$('.js-salesman-ctrl').each(function() {
			UpdateSalesmanPriceState($(this).closest('.js-order-item'), $(this), $(this).find('.salesman-value').html() === '' ? 1 : 3);
		});

		// change state of salesman controls for product [1-normal, 2-entering new price, 3-applied new price]
		function UpdateSalesmanPriceState(ItemRef, Ctrl, State) {
			Ctrl.toggleClass('has-salesman-value', Ctrl.find('.salesman-value').text() || '' !== '');
			Ctrl.find('.js-salesman-inputs').toggle(State === 2);
			if (window.innerWidth > 449) {
				Ctrl.find('.js-salesman-btn-change').css('display', State === 1 ? 'inline' : 'none');
				Ctrl.find('.js-salesman-btn-restore').css('display', State === 3 ? 'inline' : 'none');
			} else {
				Ctrl.find('.js-salesman-btn-change').css('display', State === 1 ? 'block' : 'none');
				Ctrl.find('.js-salesman-btn-restore').css('display', State === 3 ? 'block' : 'none');
			}
			RecalculatePrices(ItemRef);
		}

		// re-calculate prices in item
		function RecalculatePrices(Item) {
			const CasePackSalesman = Item.find('[data-ctrl=casepack] .salesman-value').text();
			const CasePackNormal = Item.find('[data-ctrl=casepack] .normal-value').text();
			const CasePack = CasePackSalesman || CasePackNormal;
			const PriceSalesman = Item.find('[data-ctrl=price] .salesman-value:eq(0)').text();
			const PriceNormal = Item.find('[data-ctrl=price] .normal-value:eq(0)').text();
			const FloatPrice = parseFloat(PriceSalesman ? PriceSalesman.substring(1) : PriceNormal.substring(1));
			const Qty = Item.find('.qty-wrap').text();
			const PricePerCase = CasePack * FloatPrice;
			const PricePerCaseNormal = CasePack * parseFloat(PriceNormal.substring(1));
			const Subtotal = Qty * FloatPrice;
			Item.find('[data-ctrl=price] .normal-value:eq(1)').text('$' + PricePerCaseNormal.toFixed(2));
			if (PriceSalesman) {
				Item.find('[data-ctrl=price] .salesman-value:eq(1)').text('$' + PricePerCase.toFixed(2));
			}
			Item.find('.salesman-subtotal').text('$' + Subtotal.toFixed(2));
			Item.toggleClass('has-salesman-subtotal', CasePackSalesman !== '' || PriceSalesman !== '');
		}

	},
	appendEls: function() {
		CheckoutForm.$domCouponWrap.insertAfter(CheckoutForm.$domRewOrderTable);
		$('#ContactBeforeOrder_field').find('.checkbox').append('<span class="checkmark"></span>');
	},
	populateCheckoutForm: function() {
		const data = {
			action: 'getChosenCustomer'
		};
		if (window.location.href.indexOf('/checkout') > -1) {
			$.ajax({
				url: kadraGlobal.ajax,
				type: 'POST',
				dataType: 'json',
				data: data,
				success: function(response) {
					if (response.success !== false) {
						$('#billing_first_name').val(response.data.billing.billing_first_name);
						$('#billing_last_name').val(response.data.billing.billing_last_name);
						$('#billing_company').val(response.data.billing.billing_company);
						$('#billing_address_1').val(response.data.billing.billing_address_1);
						$('#billing_address_2').val(response.data.billing.billing_address_2);
						$('#billing_country').val(response.data.billing.billing_country);
						$('#billing_city').val(response.data.billing.billing_city);
						$('#billing_postcode').val(response.data.billing.billing_postcode);
						$('#billing_state').val(response.data.billing.billing_state);
						$('#billing_phone').val(response.data.billing.billing_phone);
						$('#billing_email').val(response.data.billing.billing_email);
						setTimeout(function() {
							const billingCountryName = $('[value="' + response.data.billing.billing_country + '"]').html();
							const billingStateName = $('#billing_state_field').find('[value="' + response.data.billing.billing_state + '"]').html();
							$('#select2-billing_country-container').attr('title', billingCountryName).html(billingCountryName);
							$('#select2-billing_state-container').attr('title', billingStateName).html(billingStateName);
						}, 300);

						$('#shipping_first_name').val(response.data.shipping.shipping_first_name);
						$('#shipping_last_name').val(response.data.shipping.shipping_last_name);
						$('#shipping_company').val(response.data.shipping.shipping_company);
						$('#shipping_address_1').val(response.data.shipping.shipping_address_1);
						$('#shipping_address_2').val(response.data.shipping.shipping_address_2);
						$('#shipping_country').val(response.data.shipping.shipping_country);
						$('#shipping_city').val(response.data.shipping.shipping_city);
						$('#shipping_postcode').val(response.data.shipping.shipping_postcode);
						$('#shipping_state').val(response.data.shipping.shipping_state);
						setTimeout(function() {
							const shippingCountryName = $('[value="' + response.data.shipping.billing_country + '"]').html();
							const shippingStateName = $('#shipping_state_field').find('[value="' + response.data.shipping.billing_state + '"]').html();
							$('#select2-billing_country-container').attr('title', shippingCountryName).html(shippingCountryName);
							$('#select2-billing_state-container').attr('title', shippingStateName).html(shippingStateName);
						}, 300);

						// send form again with updated values
						setTimeout(function() {
							$('body').trigger('update_checkout');
						}, 10);
					}
				},
			});
		}
	}
};

export default CheckoutForm;
